/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { ServiceState } from './useService/useService';

export type OnSuccess<TResponse> = (state: ServiceState<TResponse>) => void;

const emptyArray: any[] = [];

function useOnServiceCallSuccess<TResponse = any>(
  serviceState: ServiceState<TResponse>,
  onSuccess: OnSuccess<TResponse>,
  deps: any[] = emptyArray,
) {
  useEffect(() => {
    if (
      !serviceState.isFetching &&
      !serviceState.error &&
      serviceState.lastFetchAttempt
    ) {
      onSuccess(serviceState);
    }
  }, [
    serviceState.isFetching,
    serviceState.error,
    serviceState.lastFetchAttempt,
    ...deps,
  ]);
}

export default useOnServiceCallSuccess;
